@if (
  endorsementLocation?.statusCode !== 'SIGNED'
  ) {
  <button class="stamp-endorsement__button"
    appDebounceClick (debouncedClick)="endorsementClicked()" [debounceTimer]="500"
    [hidden]="!endorsementLocation?.isSignableInCurrentSession"
    [tabindex]="disableFocus ? -1 : 0"
    [disabled]="isEndorsementDisabled">
    <div>Stamp<span class="fas fa-stamp stamp-endorsement__icon"></span></div>
  </button>
} @else {
  <div class="stamp-endorsement__image-wrapper">
    <img class="stamp-endorsement__image"
      [src]="'data:image/png;base64,' + endorsementImage?.endorsementImage"
      alt="notary stamp"
      data-private />
    </div>
  }

